export const handleSourceUrl = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'https://source.tutorabc.com/Md/_STAGE/scratch/asset';
    } else {
        return 'https://source.tutorabc.com/Md/scratch/asset';
    }
};

export default handleSourceUrl;
